import { clearData, logOut } from '../actions';
import { store } from '../index';
import { removeBasketBeforeLogin } from './react';

export function isAuthenticated() {
  return (window as any).keycloak?.authenticated;
}

export function getUserEmail() {
  return (window as any).keycloak?.tokenParsed?.email;
}

export function login() {
  (window as any).keycloak.login();
}

export function logout() {
  // The basket is bound to the logged-in user and would be rejected by the backend after logout
  store.dispatch(clearData('start'));
  // The API middleware falls back to these stored tokens when Keycloak has none
  store.dispatch(logOut());
  removeBasketBeforeLogin();
  (window as any).keycloak.logout();
}
